import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import classnames from 'classnames'
import ArrowRight from './icons/ArrowRight'
import ArrowLeft from './icons/ArrowLeft'

class PFPagePagination extends Component {
    _handlePageChange = (data) => {
        const {selected} = data

        this.props.onChangePage(selected + 1)
    }

    render() {
        const {
            pages,
            page,
            className,
            tableRowsPerPageSetting,
            previousLabel = <ArrowLeft color='currentColor' />,
            nextLabel = <ArrowRight color='currentColor' />,
            marginPagesDisplayed = 2,
            pageRangeDisplayed = 5,
            ...rest
        } = this.props

        if (pages <= 1) return null

        return (
            <div className={classnames('PFPagePagination Pagination', {[className]: className})}>
                {tableRowsPerPageSetting && tableRowsPerPageSetting}
                <div className={'PaginationContainer'}>
                    <ReactPaginate
                        previousLabel={previousLabel}
                        nextLabel={nextLabel}
                        pageCount={pages}
                        forcePage={page - 1}
                        marginPagesDisplayed={marginPagesDisplayed}
                        pageRangeDisplayed={pageRangeDisplayed}
                        onPageChange={this._handlePageChange}
                        containerClassName="pagination"
                        pageClassName="page-item"
                        previousClassName="Previous page-item"
                        nextClassName="Next page-item"
                        pageLinkClassName="page-link"
                        previousLinkClassName="page-link"
                        nextLinkClassName="page-link"
                        subContainerClassName="pages pagination"
                        activeClassName="active"
                        {...rest}
                    />
                </div>
            </div>
        )
    }
}

PFPagePagination.propTypes = {
    page: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    className: PropTypes.string,
    rowsPerPageSetting: PropTypes.node,
}

export default PFPagePagination
